import { useCallback, useLayoutEffect, useState } from 'react'

import { AuthModalType } from '~/utils/hooks/useAuthModal'

import { UserDataQuery } from '~/app/generated/graphql'
import { Button } from '~/components/Button/Button'
import { LoginSectionMenu } from '~/components/Header/components/RightSection/components/LoginSectionMenu'
import { HeaderProps } from '~/components/Header/Header'

import { LanguageSwitcherMobile } from '../../../LanguageSwitcher'
import { MiddleLinks } from '../../../MiddleLinks'
import { AuthButtons } from '../AuthButtons'
import { RightLinks } from '../RightLinks'

import { MenuHeader, ToogleButton } from './MobileMenu.components'
import styles from './MobileMenu.module.css'

export interface MobileMenuProps extends Pick<
  HeaderProps,
  'rightLinks' | 'middleLinks' | 'additionalMobileMenuLinks' | 'headerTranslation' | 'buttonText' | 'redirectUrl' | 'voucherLabel'
> {
  mergedTheme: { [x: string]: string }
  user?: UserDataQuery['user']
  setModalType: React.Dispatch<React.SetStateAction<AuthModalType | null>>
}

export function MobileMenu({
  middleLinks,
  additionalMobileMenuLinks,
  mergedTheme,
  user,
  rightLinks,
  headerTranslation,
  buttonText,
  redirectUrl,
  voucherLabel,
  setModalType,
}: Readonly<MobileMenuProps>) {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const toggleMenu = useCallback(() => {
    setIsMenuOpen(isMenuOpen => !isMenuOpen)
  }, [])

  useLayoutEffect(() => {
    if (isMenuOpen) document.body.style.overflow = 'hidden'
    else document.body.style.overflow = 'auto'

    return () => {
      document.body.style.overflow = 'auto'
    }
  }, [isMenuOpen])

  const combinedLinks = [...(middleLinks ?? []), ...(additionalMobileMenuLinks ?? [])].filter(link => !(link.authRequired && !user))

  return (
    <>
      <div className={styles.rightMobile}>
        {voucherLabel && (
          <Button href='/vouchers' size='small' variant='primary' className={styles.voucherButton}>
            {voucherLabel}
          </Button>
        )}
        {user && <LoginSectionMenu {...{ user, rightLinks, mergedTheme, middleLinks, headerTranslation }} />}
        <ToogleButton onClick={toggleMenu} />
      </div>
      {isMenuOpen && (
        <div className={styles.overlayContainer}>
          <div className={styles.overlay}>
            <MenuHeader onClick={toggleMenu} />
            <MiddleLinks onClick={() => setIsMenuOpen(false)} mergedTheme={mergedTheme} middleLinks={combinedLinks} isMobile />
            <RightLinks mergedTheme={mergedTheme} rightLinks={rightLinks} />
            <LanguageSwitcherMobile />
            {buttonText && redirectUrl && (
              <Button href={redirectUrl} className={mergedTheme.button} withArrow>
                {buttonText}
              </Button>
            )}
            {!user && <AuthButtons buttonsTranslations={headerTranslation.buttons} setModalType={setModalType} />}
          </div>
        </div>
      )}
    </>
  )
}
